export default function NextPageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.671337 0.381753C1.12895 -0.108045 1.88305 -0.108045 2.34067 0.381753L7.68578 6.10274L7.65676 6.13381L7.68578 6.16488L2.34067 11.8859C1.88305 12.3757 1.12895 12.3757 0.671337 11.8859C0.229346 11.4128 0.229346 10.6579 0.671337 10.1848L4.4562 6.13381L0.671337 2.08279C0.229346 1.60972 0.229346 0.854824 0.671337 0.381753Z"
        fill="currentColor"
      />
    </svg>
  );
}
